














import SortTypes from '@/utils/SortTypes';
import { defineComponent, computed } from '@vue/composition-api';
import SimpleSelect from '@/components/SimpleSelect.vue';
import KeyNamePair from '@/data/KeyNamePair';
import SharedState from '@/data/SharedState';
export default defineComponent({
  components: {
    SimpleSelect
  },
  props: {
    sortTypeKey: {
      type: String,
      required: true
    }
  },
  emits: {
    select: (value: string) => value !== undefined
  },
  setup(props, context) {
    
    const values = computed((): Array<KeyNamePair> => {
      const vals = new Array<KeyNamePair>();
      for(const type of SortTypes.types) {
        vals.push(new KeyNamePair(type.name, SharedState.getText(context, type.name)));
      }
      return vals;
    });
    
    const defaultKeyValueC = computed(() => {
      return SortTypes.getValue(props.sortTypeKey);
    });

    const onSelect = (optionValue: string) => {
      context.emit('select', SortTypes.getKey(optionValue));
    };
    return {
      values,
      onSelect,
      defaultKeyValueC
    };
  }
});
